import PropTypes from "prop-types";
import { Search, X } from "lucide-react";
import "./SearchBox.scss";

export default function SearchBox({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  showClear = true,
  className = "",
  width = "100%",
}) {
  return (
    <div className={`search-box ${className}`} style={{ width }}>
      <Search size={16} />
      <input type="text" placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} />
      {showClear && value && (
        <button className="search-box__clear" onClick={onClear}>
          <X size={14} />
        </button>
      )}
    </div>
  );
}

SearchBox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  showClear: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.string,
};
